import { IFilter } from '../models/Filter'
import { HttpRequest } from "../utils"

const httpRequest = new HttpRequest()

export const list = async ({ offset, filter, order }: IFilter) => {
  return httpRequest.post("/ord/order/backorder/list", { offset, filter, order })
}

export const get = async (data: any) => {
  return httpRequest.put(`/ord/order/backorder/get_lines`, data)
}

export const create = async (data: any) => {
  return httpRequest.post("/ord/order/backorder", data)
}
